import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGoogleLogin } from "@react-oauth/google";

import { Button } from "antd";
import { IconGoogle } from "../../components/icons";

import { commonUtil } from "../../utils";
import { loginGoogle } from "../../api";

interface Props {
  onRegisterFail?: () => void;
  onRegisterSuccess: (
    accessToken: string,
    refreshToken: string,
    expires: number
  ) => void;
}

const RegisterGoogle: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation(["common", "notification"]);
  const [loading, setLoading] = useState<boolean>(false);

  const handleLoginGoogle = async (response: any) => {
    const res = await loginGoogle({ accessToken: response.access_token });
    setLoading(false);
    if (res.status === "error") {
      commonUtil.showMessage("error", res.message);
      return;
    }
    props.onRegisterSuccess(
      res.data.access_token,
      res.data.refresh_token,
      res.data.expires_in
    );
  };

  const handleLoginGoogleFailure = async (response: any) => {
    setLoading(false);
    let textError = "";
    switch (response["error"]) {
      case "idpiframe_initialization_failed":
        textError = "initialization of the Google Auth API failed";
        break;
      case "popup_closed_by_user":
        textError =
          "The user closed the popup before finishing the sign in flow";
        break;
      case "access_denied":
        textError = "The user denied the permission to the scopes required";
        break;
      case "immediate_failed":
        textError =
          "No user could be automatically selected without prompting the consent flow";
        break;
    }
    // commonUtil.showMessage('error', textError)
  };

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => handleLoginGoogle(codeResponse),
    onError: handleLoginGoogleFailure,
  });
  return (
    // <GoogleLogin
    //   clientId={`${process.env.REACT_APP_GOOGLE_CLIENT_ID}`}
    //   render={(renderProps: any) => (
    //     <Button block={true} onClick={renderProps.onClick} loading={loading}
    //       style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    //       <IconGoogle />&nbsp;
    //       <span>{t('common:Đăng ký bằng Google')}</span>
    //     </Button>
    //   )}
    //   onRequest={() => { setLoading(true) }}
    //   onSuccess={handleLoginGoogle}
    //   onFailure={handleLoginGoogleFailure}
    //   cookiePolicy={'single_host_origin'}
    // />
    <Button
      block={true}
      onClick={() => login()}
      className="!border-red-primary"
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <IconGoogle />
      <span className="text-red-primary">
        {t("common:Đăng ký bằng Google")}
      </span>
    </Button>
  );
};

export default RegisterGoogle;
